import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_block_handle_menu = _resolveComponent("block-handle-menu")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.containerClass),
    style: _normalizeStyle($options.containerStyle)
  }, [
    _createElementVNode("iframe", {
      class: _normalizeClass($data.C.embedIframe),
      src: $props.src,
      frameborder: "0",
      allowfullscreen: "",
      loading: "lazy",
      referrerpolicy: "strict-origin-when-cross-origin",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "data-qa": "editor-embed:Iframe"
    }, null, 10 /* CLASS, PROPS */, _hoisted_1),
    ($props.editable)
      ? (_openBlock(), _createBlock(_component_block_handle_menu, {
          key: 0,
          "can-edit": true,
          onMoveUp: _cache[0] || (_cache[0] = $event => (_ctx.$emit('move-up'))),
          onMoveDown: _cache[1] || (_cache[1] = $event => (_ctx.$emit('move-down'))),
          onEdit: _cache[2] || (_cache[2] = $event => (_ctx.$emit('edit', { url: $props.src, spacing: $props.spacing }))),
          onRemove: _cache[3] || (_cache[3] = $event => (_ctx.$emit('remove'))),
          onAddBelow: _cache[4] || (_cache[4] = $event => (_ctx.$emit('add-below')))
        }))
      : _createCommentVNode("v-if", true)
  ], 6 /* CLASS, STYLE */))
}